/**
 * Route for `fraud-spike-alerts`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FraudSpikeAlertsPage } from "../features/fraud-spike-alerts/FraudSpikeAlertsPage";

export const fraudSpikeAlertsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fraud-spike-alerts",
	component: FraudSpikeAlertsPage,
});

export default fraudSpikeAlertsRoute;
